module.exports = __webpack_public_path__ + "img/bg_stay_on_top.a04a440.svg";